import { gql } from '@apollo/client/core'
import { isElectronMode } from 'src/config'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default async ({ app }) => {
  const observationResponse = null

  if (!app.config.globalProperties.$cable) return

  function subscribeToHardwareChanges (hardwareModel) {
    if (isElectronMode) return
    if (observationResponse) {
      observationResponse.unsubscribe()
    }

    if (!hardwareModel || hardwareModel.isLocal) return

    const subQuery = gql`subscription ($id: ID!){
        hardwareUpdated(id: $id) {
          hardware {
            id
            name
            lastSeenAt
            status
            config
            registerClientId
          }
        }
      }`

    const observer = app.apolloProvider.defaultClient.subscribe({
      query: subQuery,
      variables: {
        id: hardwareModel.id
      }
    })

    this.observationResponse = observer.subscribe({
      next: (data) => {
        if (!data.data.hardwareUpdated || !data.data.hardwareUpdated.hardware) return

        const hardwareData = data.data.hardwareUpdated.hardware
        hardwareData.config = JSON.parse(hardwareData.config)
        hardwareData.status = JSON.parse(hardwareData.status)

        hardware.hardwareUpdated && hardware.hardwareUpdated(hardwareData)
        hardwareModel.setData(hardwareData, true)
      },
      error (error) {
        console.error(error)
      }
    })
  }

  const hardware = {}

  hardware.subscribeToHardwareChanges = subscribeToHardwareChanges

  app.config.globalProperties.$hardware = hardware
  app.$hardware = hardware
}
